import { render, staticRenderFns } from "./LmInbox.vue?vue&type=template&id=6fbcd4dc&scoped=true"
import script from "./LmInbox.vue?vue&type=script&lang=js"
export * from "./LmInbox.vue?vue&type=script&lang=js"
import style0 from "./LmInbox.vue?vue&type=style&index=0&id=6fbcd4dc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbcd4dc",
  null
  
)

export default component.exports